module.exports = __webpack_public_path__ + "static/urwerk-8b622a4885bc25c45bd6359648ac2876.png";